import React, { useState } from "react";
import UseToast from "../../hooks/useToast";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

const SchedulePost = ({
  selectedOption,
  setSelectedOption,
  values,
  setFieldValue,
  handlePostSubmit,
  isValid,
  dirty,
  editable,
}) => {
  const { warningToast } = UseToast();
  const [hours, setHours] = useState("01");
  const [minutes, setMinutes] = useState("00");
  const today = new Date();
  const { isSavePostLoading } = useSelector((state) => state.api);
  // Validation Schema

  const handleHoursChange = (e) => {
    let value = Number(e.target.value);
    if (value > 12) value = 12;
    if (value < 1) value = 1;
    setHours(String(value).padStart(2, "0"));
  };

  const handleMinutesChange = (e) => {
    let value = Number(e.target.value);
    if (value > 59) value = 59;
    if (value < 0) value = 0;
    setMinutes(String(value).padStart(2, "0"));
  };

  const getFormattedDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const [date, setDate] = useState(getFormattedDate(today));

  const validateDate = () => {
    const [day, month, year] = date.split("/").map(Number);
    const enteredDate = new Date(year, month - 1, day);

    if (enteredDate < today) {
      warningToast("Please enter a valid date!");
    } else {
      setDate(getFormattedDate(today));
    }
  };

  const handleDateChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9/]/g, "");

    const parts = value.split("/");
    if (parts.length === 1) {
      value = parts[0].slice(0, 2);
    } else if (parts.length === 2) {
      value = `${parts[0].slice(0, 2)}/${parts[1].slice(0, 2)}`;
    } else if (parts.length === 3) {
      value = `${parts[0].slice(0, 2)}/${parts[1].slice(0, 2)}/${parts[2].slice(
        0,
        4
      )}`;
    }

    setDate(value);
  };

  return (
    <div className="bg-[#E6F7FF] shadow-md p-6 transition-all duration-700 ease-in-out text-xs rounded-lg max-w-[300px]">
      <div className="space-y-4 transition-all duration-700 ease-in-out">
        <label className="flex items-center cursor-pointer space-x-2">
          {/* <input
            type="radio"
            name="publishOption"
            value="now"
            checked={selectedOption === "now"}
            onChange={() => setSelectedOption("now")}
            className="accent-blue-500"
          /> */}
          <Field
            disabled={!editable}
            type="radio"
            name="publishOption"
            value="now"
            checked={values.publishOption === "now"}
            onChange={() => setFieldValue("publishOption", "now")}
            className="accent-blue-500"
          />

          <span className="text-gray-700">Publish Now</span>
        </label>

        <label className="flex items-center cursor-pointer transition-all duration-700 ease-in-out space-x-2">
          {/* <input
                  type="radio"
                  name="publishOption"
                  value="schedule"
                  checked={selectedOption === "schedule"}
                  onChange={() => setSelectedOption("schedule")}
                  className="accent-blue-500"
                /> */}

          <Field
            disabled={!editable}
            type="radio"
            name="publishOption"
            value="schedule"
            checked={values.publishOption === "schedule"}
            onChange={() => setFieldValue("publishOption", "schedule")}
            className="accent-blue-500"
          />

          <span className="text-gray-700">Schedule For specific Date</span>
        </label>

        {!editable && (
          <div
            className={`transition-all duration-700 ease-in-out overflow-hidden ${
              selectedOption === "schedule"
                ? "max-h-[200px] opacity-100 scale-y-100"
                : "max-h-0 opacity-0 scale-y-0"
            }`}
          >
            <div className="flex items-center space-x-2">
              {/* <input
                    type="text"
                    value={date}
                    onChange={handleDateChange}
                    onBlur={validateDate}
                    placeholder="DD/MM/YYYY"
                    className="border text-xs border-blue-500 px-2 py-1 rounded-md w-24 text-center"
                  /> */}
              {/* Date */}
              <Field
                readOnly
                disabled={!editable}
                type="text"
                name="date"
                placeholder="DD/MM/YYYY"
                className="border text-xs border-blue-500 px-2 py-1 rounded-md w-24 text-center"
              />

              <ErrorMessage
                name="date"
                component="p"
                className="text-red-500 text-xs"
              />

              {/* <input
                    type="number"
                    value={hours}
                    onChange={handleHoursChange}
                    className="border text-xs border-blue-500 px-2 py-1 rounded-md w-12"
                  /> */}

              {/* Hours */}
              <Field
                readOnly
                disabled={!editable}
                type="number"
                name="hours"
                className="border text-xs border-blue-500 px-2 py-1 rounded-md w-12"
              />
              <ErrorMessage
                name="hours"
                component="p"
                className="text-red-500 text-xs"
              />

              {/* <input
                    type="number"
                    value={minutes}
                    onChange={handleMinutesChange}
                    className="border text-xs border-blue-500 px-2 py-1 rounded-md w-12"
                  /> */}
              {/* Minutes */}
              <Field
                readOnly
                disabled={!editable}
                type="number"
                name="minutes"
                className="border text-xs border-blue-500 px-2 py-1 rounded-md w-12"
              />
              <ErrorMessage
                name="minutes"
                component="p"
                className="text-red-500 text-xs"
              />

              {/* <select className="border text-xs border-blue-500 px-2 py-1 rounded-md">
                    <option>PM</option>
                    <option>AM</option>
                  </select> */}
              {/* AM/PM Select */}

              <Field
                readOnly
                disabled={!editable}
                // as="select"
                name="period"
                className="border text-xs w-8 text-center border-blue-500  py-1 rounded-md"
              />
            </div>

            {/* <p className="text-gray-600 text-xs mt-2">Time Zone: IST</p> */}
          </div>
        )}

        <label className="flex items-center cursor-pointer space-x-2">
          {/* <input
                  type="radio"
                  name="publishOption"
                  value="queue"
                  checked={selectedOption === "queue"}
                  onChange={() => setSelectedOption("queue")}
                  className="accent-blue-500"
                /> */}

          {/* <Field
            type="radio"
            name="publishOption"
            value="queue"
            checked={values.publishOption === "queue"}
            onChange={() => setFieldValue("publishOption", "queue")}
            className="accent-blue-500"
          /> */}

          {/* <span className="text-gray-700">Add to Queue</span> */}
        </label>
      </div>
      {editable && (
        <DatePicker
          format="DD/MM/YYYY hh:mm A"
          minDate={new Date().setHours(0, 0, 0, 0)}
          plugins={[<TimePicker position="bottom" />]}
          value={values.datePickerObj || ""}
          onChange={(val) => {
            if (!val) return;
            const jsDate = val.toDate();
            const hours = jsDate.getHours();
            const minutes = jsDate.getMinutes();
            const period = hours >= 12 ? "PM" : "AM";
            const formattedHour = (((hours + 11) % 12) + 1)
              .toString()
              .padStart(2, "0");
            const formattedMinutes = minutes.toString().padStart(2, "0");
            const formattedDate = val.format("DD/MM/YYYY");

            setFieldValue("datePickerObj", val.toDate());
            setFieldValue("date", formattedDate);
            setFieldValue("hours", formattedHour);
            setFieldValue("minutes", formattedMinutes);
            setFieldValue("period", period);
          }}
          disabled={!editable || values.publishOption !== "schedule"}
          className="text-xs border-blue-500 px-2 py-1 rounded-md"
          placeholder="Pick a date and time"
        />
      )}
      {editable && (
        <div className="mt-4 flex justify-end items-center space-x-2">
          <Link to={"/social_calendar"}>
            <button
              disabled={!editable}
              className={`${
                !editable
                  ? "text-gray-600 cursor-not-allowed"
                  : "cursor-pointer"
              }px-4 py-1  rounded-md cursor-pointer hover:text-gray-600`}
            >
              Cancel
            </button>
          </Link>
          <button
            className="px-4 py-1 btn-1 h-[25px]  bg-blue-500 text-white rounded-md"
            disabled={isSavePostLoading || !(isValid && dirty)}
            onClick={() => handlePostSubmit(values)}
          >
            {values.publishOption === "schedule" ? "Schedule" : "Post"}
          </button>
        </div>
      )}
    </div>
  );
};

export default SchedulePost;
